import "./AboutFarmFox.css";

function AboutFarmFox() {

    const handleReadMore = () => {
        window.location.href = "/about-us";
    };

    return (
        <section className="about-farmfox">

            <div className="about-container">

                <div className="divider-top"></div>

                <h2 className="about-title">
                    FarmFox's Journey
                </h2>

                <p className="about-description">
                    FarmFox was born with a simple mission—to bring the authentic goodness of premium Mithila
                    Makhana from the pristine ponds of North Bihar to health-conscious families across India.
                    Every kernel is carefully sourced from trusted farmers, naturally harvested, and thoughtfully
                     processed to preserve its purity, crunch, and nutritional richness.

                    <br /><br />

                    More than just a snack, Makhana is a centuries-old superfood cherished 
                    for its high protein, low calorie content, and wholesome nutrition.
                    At FarmFox, we combine traditional farming heritage with modern quality
                    standards to deliver products that are clean, delicious, and worthy 
                    of your everyday lifestyle.From sacred waters to your table, our journey
                    is driven by quality, sustainability, and a commitment to making healthy
                    snacking both enjoyable and accessible. Every FarmFox pack reflects our 
                    promise of freshness, authenticity, and uncompromising excellence.
                </p>

                <button
                    className="read-more-btn"
                    onClick={handleReadMore}
                >
                    READ MORE
                </button>

                <div className="divider-bottom"></div>

            </div>

        </section>
    );
}

export default AboutFarmFox;